module.exports = __webpack_public_path__ + "img/fevend-product-page.0e907b2f.webp";